/*
 * Helper functions for translations
*/

export interface TranslatedDescription {
	translatedDescription?: string | null;
	description?: string | null;
	title?: string | null;
	name?: string | null;
}

/** Returns the translated description, falling back to the original description. */
export const getTranslatedDescription = (value?: TranslatedDescription | null): string => {
	return value?.translatedDescription || value?.description || value?.title || value?.name || '';
};
